export default "__VITE_ASSET__BPVNXd5A__"